import { lazy, useMemo } from "react";
import { useSelector } from "react-redux";
import { skipToken } from "@reduxjs/toolkit/dist/query";

import { selectCurrentAccount, useGetInvitationsQuery } from "fond/api";

import { SettingsTabbedContent } from "../SettingsTabbedContent";

import { UserManagementTabContent } from "../common.styles";
import { TabBadge } from "./PendingInvites/PendingInvites.styles";

const UserListTab = lazy(() => import("./UserList/UserList"));
const PendingInvitesTab = lazy(() => import("./PendingInvites/PendingInvites"));

const UserManagement: React.FC = () => {
  const selectedAccount = useSelector(selectCurrentAccount);
  const { data: pendingInvites } = useGetInvitationsQuery(selectedAccount?.ID ?? skipToken);

  const tabs = useMemo(
    () => [
      { label: "User List", path: "list", component: UserListTab },
      { label: <TabBadge badgeContent={pendingInvites?.length}>Pending Invites</TabBadge>, path: "pending-invites", component: PendingInvitesTab },
    ],
    [pendingInvites?.length]
  );

  return <SettingsTabbedContent prefix="/settings/users" tabs={tabs} ContentContainer={UserManagementTabContent} data-testid="user-management" />;
};

export default UserManagement;
